export class Zwiazek {
    constructor(symbol)  {
        this.maxRozpuszczalnosc = 1000;
        this.grupy = {};
        this.symbol = symbol.toUpperCase();        
    }
    procent(grupa) {
        var val = this.grupy[grupa.toUpperCase()];
        if (!val) val = 0;
        return val;
    }
    zawiera(grupa, procent) {
        this.grupy[grupa.toUpperCase()] = parseFloat(procent);
        return this;
    }
    rozpuszczalnosc(gramowNaLitr) {
        this.maxRozpuszczalnosc = parseFloat(gramowNaLitr);
        if (this.maxRozpuszczalnosc < 0)
            this.maxRozpuszczalnosc = 1000;
        return this;
    }
    usunGrupe(symbolGrupy) {
        delete this.grupy[symbolGrupy];
    }    
    zapisz(stan) {
        stan.symbol = this.symbol;
        stan.rozpuszczalnosc = this.maxRozpuszczalnosc;
        stan.grupy = {};
        for (var i in this.grupy)
            stan.grupy[i] = this.grupy[i];
    }
    wczytaj = function (stan) {
        this.symbol = stan.symbol.toUpperCase();
        this.maxRozpuszczalnosc = parseFloat(stan.rozpuszczalnosc);
        this.grupy = {};
        for (var i in stan.grupy)
            this.grupy[i.toUpperCase()] = parseFloat(stan.grupy[i]);
    }
}

export class MakroSkladnik {
    constructor(skladnik) {
        this.skladnik = skladnik;
        this.rozpuszczony = true;
        this.ilosc = 0;    
        this.uzywany = false;    
    }    
    uzytaIlosc() {
        var ile = 0;
        if (this.uzywany)
            ile = this.ilosc;
        return ile;
    }
    sumaGrupy(symbolGrupy) {        
        return this.uzytaIlosc() * (this.skladnik.procent(symbolGrupy) / 100);
    }
    rozpuscW(ileGramowWody) {
        ileGramowWody = parseFloat(ileGramowWody);
        if (ileGramowWody < 0) ileGramowWody = 0;
        this.rozpuszczony = this.ilosc <= (this.skladnik.maxRozpuszczalnosc * ileGramowWody / 1000);
    }
    zapisz(stan) {
        stan.symbol = this.symbol();
        stan.ilosc = this.ilosc;
        stan.uzywany = this.uzywany;
    }
    wczytaj(stan) {
        if (stan.symbol != this.symbol()) return;
        this.ilosc = stan.ilosc;
        this.uzywany = stan.uzywany;
    }
    symbol() {
        return this.skladnik.symbol;
    }    
}

export class GrupaMakro{
    constructor(symbol) {
        this.symbol = symbol.toUpperCase();
        this.ilosc = 0;
    }
}

export default class Makro {
    constructor() {
        this.id = 0;
        this.skladniki = [];
        this.grupy = [];
        this.stezenia = [];
        this.masa = 0;
        this.pojemnosc = 100;
        this.ilosc = 100;
        this.iloscWszystko = false;
        this.nazwa = "";
        this.pokazNieuzywane = true;

        this.skladnik("h2o").zawiera("h2o", 100);
        this.skladnik("kno3").rozpuszczalnosc(470).zawiera("k", 38.672).zawiera("no3", 61.3);
        this.skladnik("nh4no3").rozpuszczalnosc(1920).zawiera("nh4", 22.53).zawiera("no3", 77.47);
        this.skladnik("co(nh2)2").rozpuszczalnosc(480).zawiera("nh2", 54.2);
        this.skladnik("kh2po4").rozpuszczalnosc(226).zawiera("k", 28.731).zawiera("po4", 69.8);
        this.skladnik("k2hpo4").rozpuszczalnosc(1500).zawiera("k", 22.4).zawiera("po4", 54.5);
        this.skladnik("khco3").rozpuszczalnosc(240).zawiera("k", 39.1);
        this.skladnik("mgso4").rozpuszczalnosc(330).zawiera("mg", 20.2);
        this.skladnik("mgso4*7h2o").rozpuszczalnosc(710).zawiera("mg", 9.9);
        this.skladnik("Mg(NO3)2*6H2O").rozpuszczalnosc(420).zawiera("Mg", 9.4).zawiera("NO3", 48.4);
        this.skladnik("k2so4").rozpuszczalnosc(111).zawiera("k", 44.874);
        this.skladnik("kcl").rozpuszczalnosc(340).zawiera("k", 52);
        this.skladnik("caso4*2h2o").rozpuszczalnosc(2.55).zawiera("ca", 27.612);
        this.skladnik("ca(no3)2*4h2o").rozpuszczalnosc(4000).zawiera("ca", 17.0).zawiera("no3", 52.5);
        this.grupa("no3");
        this.grupa("nh4");
        this.grupa("nh2");
        this.grupa("po4");
        this.grupa("k");
        this.grupa("mg");
        this.grupa("ca");
    }
    zerujGrupy() {
        for (var nrGrupy in this.grupy) {
            var grupa = this.grupy[nrGrupy];
            grupa.ilosc = 0;
        }
    }
    znajdzSkladnik(symbol) {
        symbol = symbol.toUpperCase();
        for (var nrSkladnika in this.skladniki)
            if (this.skladniki[nrSkladnika].symbol() === symbol)
                return this.skladniki[nrSkladnika];
        return null;
    }
    przeliczStezenia() {
        this.stezenia = [];
        var procent = this.ilosc / this.masa;        

        for (var nrGrupy in this.grupy) {
            var grupa = this.grupy[nrGrupy];
            if (grupa.ilosc > 0) {
                var miligramy = grupa.ilosc * procent * 1000;
                this.stezenia.push({ symbol: grupa.symbol, ppm: miligramy / this.pojemnosc });
            }
        }
    }
    przelicz() {
        this.masa = 0;
        this.zerujGrupy();        
        var ileWody = this.znajdzSkladnik("h2o").uzytaIlosc();
        if (this.iloscWszystko)
            ileWody = this.pojemnosc * 1000;

        for (var nrSkladnika in this.skladniki) {
            var skladnik = this.skladniki[nrSkladnika];
            skladnik.rozpuscW(ileWody);
            if (skladnik.uzywany) {
                var ilosc = parseFloat(skladnik.ilosc);
                if (!isNaN(ilosc))
                    this.masa += ilosc;
                for (var nrGrupy in this.grupy) {
                    var grupa = this.grupy[nrGrupy];
                    grupa.ilosc += skladnik.sumaGrupy(grupa.symbol);
                }
            }
        }
        if (this.iloscWszystko) this.ilosc = this.masa;
        this.przeliczStezenia();
    }
    zapisz(stan) {
        stan.id = this.id;
        stan.pojemnosc = this.pojemnosc;
        stan.ilosc = this.ilosc;
        stan.nazwa = this.nazwa;
        stan.pokazNieuzywane = this.pokazNieuzywane;
        stan.skladniki = [];
        stan.iloscWszystko = this.iloscWszystko;
        for (var i in this.skladniki) {
            var skladnik = this.skladniki[i];
            var stanSkladnika = {};
            skladnik.zapisz(stanSkladnika);
            stan.skladniki.push(stanSkladnika);
        }
    }
    wczytaj = function (stan) {
        this.id = stan.id;
        this.pojemnosc = stan.pojemnosc;
        this.ilosc = stan.ilosc;
        this.nazwa = stan.nazwa;
        this.pokazNieuzywane = stan.pokazNieuzywane;
        this.iloscWszystko = stan.iloscWszystko;
        for (var i in stan.skladniki) {
            var stanSkladnika = stan.skladniki[i];
            var skladnik = this.znajdzSkladnik(stanSkladnika.symbol);
            if (skladnik)
                skladnik.wczytaj(stanSkladnika);
        }
    }
    skladnik(symbol) {
        var zwiazek = new Zwiazek(symbol);
        var nowy = new MakroSkladnik(zwiazek);
        this.skladniki.push(nowy);
        return zwiazek;
    }
    grupa(symbol) {
        this.grupy.push(new GrupaMakro(symbol));
    }    
}